import {
  get,
  post,
  put,
  del, patch,
} from '@/utils/request';

const url = 'stores';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getTodayOtherStoreReservations(data) {
  return get({
    url: `${url}/today-other-store-reservations`,
    data,
  });
}

export function getStoreCardTypes() {
  return get({
    url: `${url}/card-types`,
  });
}

export function getStoreTeacherLadderSalaries(id) {
  return get({
    url: `${url}/${id}/teacher-ladder-salaries`,
  });
}

export function updateTeacherLadderSalaries(data) {
  return put({
    url: `${url}/teacher-ladder-salaries`,
    data,
  });
}

export function getCustomers() {
  return get({
    url: `${url}/customers`,
  });
}

export function getSortedStores() {
  return get({
    url: `${url}/sorts`,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function getQrCodeByStoreId(storeId) {
  return get({
    url: `${url}/${storeId}/qr-codes`,
  });
}

export function getStoreItemQrCodes(data) {
  return get({
    url: 'store-item-qr-codes',
    data,
  });
}

export function createStoreItemQrCode(data) {
  return post({
    url: 'store-item-qr-codes',
    data,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function updateRent(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
